import type { VendorRiskLevel } from '@common/types'
import { StatusBadge, type StatusVariant } from './status-badge'

const riskConfig: Record<VendorRiskLevel, { variant: StatusVariant }> = {
  None: { variant: 'neutral' },
  Low: { variant: 'success' },
  Moderate: { variant: 'warning' },
  High: { variant: 'error' },
}

export function VendorRiskBadge({ risk }: { risk: VendorRiskLevel | null }) {
  if (!risk) return <span className="text-muted-foreground">—</span>
  const config = riskConfig[risk] ?? { variant: 'neutral' as StatusVariant }
  return <StatusBadge label={risk} variant={config.variant} />
}
